<!--view for profile-->
<template>
    <div class="profile">
      <Heading/>
      <ProfilePage/>
    </div>
</template>

<script>
import Heading from '@/components/Heading.vue';
import ProfilePage from '@/components/ProfilePage.vue';
import { mapGetters } from "vuex";

export default {
  name: 'Profile',
  components: { Heading, ProfilePage},
    computed: {
    ...mapGetters({
      profile: 'profile',
    })
  },
  mounted: async function() {
    await this.$store.dispatch('getProfile');
    this.$store.commit('SELECTED_PROFILE_LOADED', this.profile); 
    this.$store.commit('PROFILE_LOADED', this.profile);    
  }
  }
</script>